import Placeholders from './placeholders/index';

export default class Blog {
  placeholders = new Placeholders();

  initialize = () => {
    this.placeholders.initialize();
  };
}
